module.exports = __webpack_public_path__ + "img/hj-bg4.1fa90fd1.jpg";